import { render, staticRenderFns } from "./SettingsWhatsApp.vue?vue&type=template&id=315428c6&scoped=true"
import script from "./SettingsWhatsApp.vue?vue&type=script&lang=js"
export * from "./SettingsWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./SettingsWhatsApp.vue?vue&type=style&index=0&id=315428c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315428c6",
  null
  
)

export default component.exports